
















import Vue from 'vue'
import { renderAuthUI, observeUser, signOut } from '@/firebaseApp'

export default Vue.extend({
  name: 'Authenticated',
  data() {
    observeUser(user => (this.user = user))
    return {
      user: null as firebase.User | null,
    }
  },
  mounted() {
    this.renderLogin()
  },
  computed: {
    loggedIn: function() {
      return this.user !== null
    },
    email: function() {
      return this.user?.email
    },
  },
  methods: {
    async signOut() {
      await signOut()
      this.renderLogin()
    },
    renderLogin() {
      const ref = this.$refs['firebaseui-auth-container'] as HTMLElement
      renderAuthUI(ref)
    },
  },
  watch: {
    async user() {
      if (this.user?.isAnonymous) {
        await signOut()
        this.renderLogin()
      }
    },
  },
})
